import { AD_DETAILS_API_IDS } from './general';

/**
 * Normalise un texte pour la comparaison (lowercase, sans accents)
 */
function normalizeText(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Supprime les accents
    .trim();
}

/**
 * Vérifie si une valeur est présente comme mot entier dans le titre
 */
function isValueInTitle(normalizedTitle, value) {
  const normalizedValue = normalizeText(value);
  if (!normalizedValue) return false;

  // Split le titre en mots et cherche une correspondance exacte
  const titleWords = normalizedTitle.split(/[\s\-_/,;:.!?'"()]+/);
  return titleWords.includes(normalizedValue);
}

/**
 * Vérifie si une taille numérique est présente avec préfixe T (ex: "T44" -> "44")
 */
function isSizeWithPrefixInTitle(normalizedTitle, sizeValue) {
  if (!/^\d+$/.test(sizeValue)) return false;

  const titleWords = normalizedTitle.split(/[\s\-_/,;:.!?'"()]+/);
  return titleWords.includes(`t${sizeValue}`);
}

/**
 * Extrait les valeurs d'attributs depuis un titre en les matchant
 * avec les attributs disponibles (liste fermée uniquement)
 *
 * @param {string} title - Le titre de l'annonce
 * @param {Array} categoryAttributes - Les attributs disponibles pour la catégorie
 * @param {Object} currentAttributes - Les attributs actuellement remplis (pour ne pas écraser)
 * @returns {Object} - Les attributs trouvés { couleur: 'Rose', taille: 'XS', ... }
 */
export function extractAttributesFromTitle(title, categoryAttributes, currentAttributes = {}) {
  if (!title || !categoryAttributes || categoryAttributes.length === 0) {
    return {};
  }

  const normalizedTitle = normalizeText(title);
  const results = {};

  // Filtrer uniquement les attributs de type radiobutton (liste fermée)
  const closedListAttributes = categoryAttributes.filter((attr) => attr.type === AD_DETAILS_API_IDS.TYPES.RADIO.MAIN_KEY);

  for (const attribute of closedListAttributes) {
    const { key, choices } = attribute;

    // Ne pas écraser les valeurs déjà remplies par l'utilisateur
    if (currentAttributes[key]) {
      continue;
    }

    if (!choices || choices.length === 0) {
      continue;
    }

    // Trier les choices par longueur décroissante pour matcher les plus spécifiques d'abord
    // Ex: "The North Face" avant "North"
    const sortedChoices = [...choices].sort((a, b) => (b.value?.length || 0) - (a.value?.length || 0));

    const isSizeAttribute = key === AD_DETAILS_API_IDS.ATTRIBUTES.TAILLE.MAIN_KEY;

    for (const choice of sortedChoices) {
      if (!choice.value) continue;

      // Match standard
      if (isValueInTitle(normalizedTitle, choice.value)) {
        results[key] = choice.value;
        break;
      }

      // Match spécial pour les tailles numériques avec préfixe T (ex: "T44" -> "44")
      if (isSizeAttribute && isSizeWithPrefixInTitle(normalizedTitle, choice.value)) {
        results[key] = choice.value;
        break;
      }
    }
  }

  return results;
}
